/**
 * Free Shipping Progress Bar Module
 * Gère la logique de la barre de progression pour la livraison offerte
 */

(function() {
	'use strict';

	// Attendre que window.cart soit défini (depuis cart-drawer.liquid)
	if (typeof window.cart === 'undefined') {
		// Réessayer après un court délai
		setTimeout(function() {
			if (typeof window.cart !== 'undefined') {
				initFreeShippingModule();
			}
		}, 100);
	} else {
		initFreeShippingModule();
	}

	function initFreeShippingModule() {
		if (!window.cart) {
			return;
		}

		var deliveryModuleWidth = 100;
		var renderFirst = 0;

		var nbSteps = window.cart.nbSteps;
		if (nbSteps > 1 && nbSteps < 3) {
			deliveryModuleWidth = 33.33;
		} else if (nbSteps > 2) {
			deliveryModuleWidth = 25;
		}

		var ajaxCartProducts = function (qty1) {
			var objUpdate = { updates: {} };
			objUpdate.updates[44816234283284] = qty1;

			$.ajax({
				type: 'POST',
				url: '/cart/update.js',
				data: objUpdate,
				dataType: 'json',
				success: function (response) {
					// Invalider le cache après modification
					if (typeof window.CartCache !== 'undefined') {
						window.CartCache.invalidate();
					}
					
					if (typeof window.renderCart === 'function') {
						window.renderCart();
					}
				},
				error: function (error) {
					// Error handling
				},
			});
		};

		// Fonction pour calculer les seuils dynamiquement depuis les produits
		var calculateDynamicThresholds = function () {
			var thresholds = [];
			var vendors = [];
			var allHaveThreshold = true;

			$('.cart__item--container').each(function (index) {
				var vendor = $(this).attr('data-vendor');
				var vendorHandle = $(this).attr('data-vendor-handle');
				var collections = $(this).attr('data-collections');
				var collectionTitle = $(this).attr('data-collection-title');
				var threshold = $(this).attr('data-free-delivery-threshold');
				var collectionFound = $(this).attr('data-collection-found');
				var isProtectOrder = $(this).hasClass('protect-order');
				
				// Ignorer les produits ProtectMyOrder dans le comptage des vendors
				if (vendor && vendor !== '' && !isProtectOrder && vendor.toLowerCase() !== 'protectmyorder') {
					if (vendors.indexOf(vendor) === -1) {
						vendors.push(vendor);
					}
				}
				
				// Ne pas vérifier le seuil pour ProtectMyOrder
				if (!isProtectOrder && vendor && vendor.toLowerCase() !== 'protectmyorder') {
					if (!threshold || threshold === '') {
						allHaveThreshold = false;
					} else {
						// Convertir le seuil en centimes (comme les steps)
						var thresholdValue = parseFloat(threshold) * 100;
						if (thresholds.indexOf(thresholdValue) === -1) {
							thresholds.push(thresholdValue);
						}
					}
				}
			});
			
			// Si plusieurs vendors (ProtectMyOrder exclu) ou pas tous les produits ont un seuil, retourner null
			if (vendors.length > 1) {
				return null;
			}
			
			if (!allHaveThreshold || thresholds.length === 0) {
				return null;
			}
			
			// Trier les seuils par ordre croissant
			thresholds.sort(function(a, b) {
				return a - b;
			});
			
			return thresholds;
		};

		var shippingBarLogic = function (total) {
			// Calculer les seuils dynamiquement si en mode dynamique
			var steps = window.cart.steps;
			if (window.cart.dynamicThreshold) {
				var dynamicSteps = calculateDynamicThresholds();
				if (dynamicSteps && dynamicSteps.length > 0) {
					steps = dynamicSteps;
				} else {
					// Si pas de seuil trouvé, masquer la barre
					$('#deliver--cart-drawer').addClass('hidden');
					return;
				}
			}
			
			var currentStep = 1;
			if (steps[0] && total >= steps[0] && steps[1] && total < steps[1]) {
				currentStep = 2;
			} else if (steps[1] && total >= steps[1]) {
				currentStep = 3;
			}

			var remainMoney = 0;
			var remainPercentage = 0;
			var colorBar = 0;

			var barCalculus = function (step, total) {
				var seuilSuivant = steps[step - 1];
				var seuilPrecedent = 0;
				if (step != 1) {
					seuilPrecedent = steps[step - 2];
				}

				remainMoney = Math.max(0, (seuilSuivant - total) / 100);
				remainPercentage = Math.max(
					0,
					(seuilSuivant - total) / (seuilSuivant - seuilPrecedent)
				);
				colorBar =
					deliveryModuleWidth * step - deliveryModuleWidth * remainPercentage;
			};

			var finalStep = function () {
				remainMoney = 0;
				remainPercentage = 0;
				colorBar = 100;
			};

			switch (currentStep) {
				case 1:
					barCalculus(1, total);
					break;
				case 2:
					barCalculus(2, total);
					break;
				case 3:
					barCalculus(3, total);
					break;
				default:
					break;
			}

			if (currentStep == 1) {
				//ajaxCartProducts(0);
			} else if (currentStep == 2 && nbSteps > 1) {
				if (nbSteps == 1) {
					finalStep();
				} else {
					if (window.cart.deliveryStep == 1) {
						//ajaxCartProducts(0);
					} else {
						//ajaxCartProducts(1);
					}
				}
			} else {
				finalStep();
				if (window.cart.deliveryStep == 0 && nbSteps == 2) {
					//ajaxCartProducts(1);
				} else if (window.cart.deliveryStep == 0 && nbSteps == 1) {
					//ajaxCartProducts(1);
				} else if (
					(window.cart.deliveryStep == 1 || window.cart.deliveryStep == 2) &&
					nbSteps == 2
				) {
					//ajaxCartProducts(1);
				} else {
					//ajaxCartProducts(0);
				}
			}

			$('#progress__bar--remain').css('width', colorBar + '%');

			if (remainMoney > 0) {
				var moinsDix = remainMoney < 10 ? true : false;
				remainMoney = remainMoney.toString().replace('.', ',');
				if (moinsDix == true && remainMoney.length == 3) {
					remainMoney = remainMoney + '0';
				} else if (moinsDix == false && remainMoney.length == 4) {
					remainMoney = remainMoney + '0';
				}

				$('#free__shipping--message').hide();
				$('#remain__shipping__amount--message').show();
				$('#amount__remaining').text(remainMoney + '€');
			} else {
				$('#free__shipping--message').show();
				$('#remain__shipping__amount--message').hide();
			}
		};

		var getCartTotal = function (callback, cart) {
			if (cart) {
				if (callback) {
					callback(cart.total_price);
				} else {
					return cart.total_price;
				}
			} else {
				$.ajax({
					type: 'GET',
					url: '/cart.js',
					dataType: 'json',
					success: function (cart) {
						if (callback) {
							callback(cart.total_price);
						} else {
							return cart.total_price;
						}
					},
				});
			}
		};

		var initializeDeliveryModule = function () {
			var total = getCartTotal(shippingBarLogic);
		};

		// Fonction pour mettre à jour la barre de progression
		var updateDeliveryModule = function (total) {
			if (window.cart.deliveryModule) {
				if (total) {
					shippingBarLogic(total);
				} else {
					getCartTotal(shippingBarLogic);
				}
			}
		};

		// ============================================
		// FONCTIONS HELPER POUR updateGiftBar
		// ============================================

		/**
		 * Vérifie si la barre doit être masquée en fonction des vendors et seuils
		 * @returns {boolean} true si la barre doit être masquée
		 */
		var shouldHideGiftBar = function () {
			var hideBar = false;

			// Vérifier si un produit a cacher_livraison_offerte = true
			$('.cart__item--container').each(function (index, element) {
				var hide = $(this).attr('hideBar');
				if (hide === 'true') {
					hideBar = true;
				}
			});

			// Si mode dynamique, vérifier les vendors et les seuils
			if (window.cart && window.cart.dynamicThreshold && !hideBar) {
				var vendors = [];
				var hasThreshold = false;
				var allHaveThreshold = true;

				$('.cart__item--container').each(function () {
					var vendor = $(this).attr('data-vendor');
					var threshold = $(this).attr('data-free-delivery-threshold');
					var isProtectOrder = $(this).hasClass('protect-order');

					// Ignorer les produits ProtectMyOrder dans le comptage des vendors
					if (vendor && vendor !== '' && !isProtectOrder && vendor.toLowerCase() !== 'protectmyorder') {
						if (vendors.indexOf(vendor) === -1) {
							vendors.push(vendor);
						}
					}

					// Ne pas vérifier le seuil pour ProtectMyOrder
					if (!isProtectOrder && vendor && vendor.toLowerCase() !== 'protectmyorder') {
						if (threshold && threshold !== '') {
							hasThreshold = true;
						} else {
							allHaveThreshold = false;
						}
					}
				});

				// Masquer si plusieurs vendors (ProtectMyOrder exclu) ou si aucun seuil trouvé
				if (vendors.length > 1) {
					hideBar = true;
				} else if (!hasThreshold || !allHaveThreshold) {
					hideBar = true;
				}
			}

			return hideBar;
		};

		/**
		 * Traite la réponse du panier et met à jour l'affichage de la barre
		 * @param {Object} response - Réponse du panier (depuis cache ou AJAX)
		 * @param {number} perfStart - Timestamp de début pour les logs de perf
		 * @param {number} ajaxDuration - Durée de récupération des données
		 */
		var processGiftBarResponse = function (response, perfStart, ajaxDuration) {
			const domStart = performance.now();
			var empty = response.item_count == 0;

			if (empty) {
				$('#deliver--cart-drawer').addClass('hidden');
			} else {
				var hideBar = shouldHideGiftBar();

				if (hideBar) {
					$('#deliver--cart-drawer').addClass('hidden');
				} else {
					$('#deliver--cart-drawer').removeClass('hidden');
				}
			}

			const domDuration = performance.now() - domStart;
			const totalDuration = performance.now() - perfStart;

			if (window.CartEventManager && window.CartEventManager.PerformanceLogger) {
				window.CartEventManager.PerformanceLogger.log('Update Gift Bar', {
					ajaxDuration: `${ajaxDuration.toFixed(2)}ms`,
					domDuration: `${domDuration.toFixed(2)}ms`,
					total: `${totalDuration.toFixed(2)}ms`
				});
			}
		};

		// ============================================
		// FONCTION PRINCIPALE
		// ============================================

		// Fonction pour mettre à jour l'affichage de la barre (vendors, seuils, etc.)
		var updateGiftBar = function () {
			const perfStart = performance.now();

			/**
			 * Helper pour construire l'URL du panier selon la langue
			 */
			var getCartUrl = function () {
				var url = '/cart';
				if (window.general && window.general.langue != 'fr') {
					url = `/${window.general.langue}/cart`;
				}
				return url;
			};

			// Utiliser le cache si disponible, sinon fallback sur l'ancienne méthode
			if (typeof window.CartCache !== 'undefined' && window.CartCache.get) {
				window.CartCache.get().then(function (response) {
					const ajaxDuration = performance.now() - perfStart;
					processGiftBarResponse(response, perfStart, ajaxDuration);
				}).catch(function (error) {
					// Fallback sur l'ancienne méthode en cas d'erreur
					$.ajax({
						type: 'GET',
						url: getCartUrl(),
						dataType: 'json',
						success: function (response) {
							const ajaxDuration = performance.now() - perfStart;
							processGiftBarResponse(response, perfStart, ajaxDuration);
						}
					});
				});
			} else {
				// Fallback si CartCache n'est pas disponible
				$.ajax({
					type: 'GET',
					url: getCartUrl(),
					dataType: 'json',
					success: function (response) {
						const ajaxDuration = performance.now() - perfStart;
						processGiftBarResponse(response, perfStart, ajaxDuration);
					}
				});
			}
		};

		// Exposer les fonctions globalement pour qu'elles soient accessibles depuis theme-apm.js
		window.updateGiftBar = updateGiftBar;
		window.updateDeliveryModule = updateDeliveryModule;

		// Initialiser le module si le panier n'est pas vide
		if (window.cart.emptyCart == false) {
			setTimeout(function () {
				initializeDeliveryModule();
			}, 1000);
		}
	}
})();

